export const useEmbeddedCheckout = () => {
  const router = useRouter()

  // Route parameters
  const supplierIdParam = computed(
    () => router.currentRoute.value.query.supplierId
  )
  const eventDescriptionIdParam = computed(
    () => router.currentRoute.value.query.eventDescriptionId
  )
  const isEmbedded = computed(
    () => router.currentRoute.value.query.embedded === 'true'
  )

  return {
    /* Variables */
    supplierIdParam,
    eventDescriptionIdParam,
    isEmbedded,
  }
}
